import React from "react";
import axios from "axios";
import "../../../assets/features.css";
import { BASE_URL, COLORS, HEADERS } from "../../../common/api";
import { DeleteButton, EditButton, AddButton } from "../../../assets/js/Button";
import { Modal, Form, Button } from "react-bootstrap";

class Color extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: [],
      show: false,
      confirm: false,
      nameUz: "",
      nameRu: "",
      color_code: "",
      extra_color: "",
      id: "",
    };
    this._isMounted = false;
  }
  componentDidMount() {
    this._isMounted = true;
    this._isMounted &&
      axios.get(BASE_URL + COLORS).then((res) => {
        console.log(res.data);
        this.setState({ colors: res.data });
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.show && !this.state.show) {
      this.setState({
        show: false,
        nameUz: "",
        nameRu: "",
        color_code: "",
        extra_color: "",
        id: "",
      });
    }
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  showModal = () => {
    this.setState({ show: true });
  };

  showConfirmationModal = (event, id) => {
    this.setState({ confirm: true, id: id });
  };

  hideModal = () => {
    this.setState({ show: false, confirm: false });
  };

  get = (data) => {
    this.setState({
      nameUz: data.nameUz,
      nameRu: data.nameRu,
      color_code: data.color_code,
      extra_color: data.extra_color,
      id: data.id,
      show: true,
    });
  };

  delete = (id) => {
    const { colors } = this.state;
    axios.delete(BASE_URL + COLORS + id).then((res) => {
      const updatedData = colors.filter((color) => color.id !== id);
      this.setState({ colors: updatedData, confirm: false });
    });
  };

  addOrUpdate = (event) => {
    event.preventDefault();
    const { nameUz, nameRu, color_code, extra_color, id } = this.state;
    let data = {
      nameUz: nameUz,
      nameRu: nameRu,
      color_code: color_code,
      extra_color: extra_color,
    };

    if (id) {
      axios.put(BASE_URL + COLORS + id + "/", data, HEADERS).then((res) => {
        const { colors } = this.state;
        const index = colors.findIndex((color) => color.id === id);
        colors[index] = res.data;
        this.setState({ colors: colors, show: false });
      });
    } else {
      axios.post(BASE_URL + COLORS, data, HEADERS).then((res) => {
        this.setState({
          colors: [...this.state.colors, res.data],
          show: false,
        });
      });
    }
  };

  getTitle = () => {
    const { id } = this.state;
    if (id) {
      return <h3>Изменить</h3>;
    } else {
      return <h3>Добавить новый</h3>;
    }
  };

  render() {
    const { show, confirm, nameUz, nameRu, color_code, extra_color, id } =
      this.state;
    const { permission } = this.props;
    return (
      <>
        <Modal
          show={show}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.getTitle()}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(event) => this.addOrUpdate(event)}>
              <Form.Group className="mb-3" key={id}>
                <Form.Label>O'zbekcha nomlanishi:</Form.Label>
                <Form.Control
                  type="text"
                  name="nameUz"
                  value={nameUz}
                  onChange={this.handleChange}
                />
                <Form.Label>Наименование Ru:</Form.Label>
                <Form.Control
                  type="text"
                  name="nameRu"
                  value={nameRu}
                  onChange={this.handleChange}
                />
                <div className="row p-4">
                  <Form.Label>Основной цвет:</Form.Label>
                  <Form.Control
                    type="color"
                    name="color_code"
                    value={color_code}
                    onChange={this.handleChange}
                  />
                  <Form.Label className="px-2">Дополнительный цвет:</Form.Label>
                  <Form.Control
                    type="color"
                    name="extra_color"
                    value={extra_color}
                    onChange={this.handleChange}
                  />
                </div>
              </Form.Group>
              <Button variant="primary" type="submit" onClick={this.showModal}>
                Сохранить
              </Button>
            </Form>
          </Modal.Body>
        </Modal>
        <section id="tab-item-2">
          {permission && <AddButton onClick={() => this.showModal()} />}

          <table className="table table-hover">
            <thead className="thead-light">
              <tr>
                <th>O'zbekcha nomlanishi</th>
                <th>Наименование Ru</th>
                <th>Визуально</th>
                <th>Код цвета</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {this.state.colors.map((color) => (
                <tr key={color.id}>
                  <td>{color.nameUz}</td>
                  <td>{color.nameRu}</td>
                  <th>
                    <div className="colors">
                      <div
                        className="color-span"
                        style={{ backgroundColor: color.color_code }}
                      ></div>
                      <div
                        className="color-span"
                        style={{ backgroundColor: color.extra_color }}
                      ></div>
                    </div>
                  </th>
                  <td>
                    {color.color_code} {color.extra_color}
                  </td>
                  <td>
                    {permission && (
                      <EditButton onClick={() => this.get(color)} />
                    )}
                    {permission && (
                      <DeleteButton
                        onClick={(event, id) =>
                          this.showConfirmationModal(event, color.id)
                        }
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>
        <Modal
          show={confirm}
          onHide={() => {
            this.hideModal();
          }}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Удалить</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h5>Вы уверены, что хотите удалить эту информацию?</h5>
            <button
              className="btn btn-danger m-1"
              onClick={(event) => this.delete(id, event)}
            >
              Удалить
            </button>
            <button
              className="btn btn-light outline-secondary"
              onClick={() => {
                this.hideModal();
              }}
            >
              Назад
            </button>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default Color;
